export default __webpack_public_path__ + "NoVideoAvailable.2953eb78.jpg";